import {Category, Order, OrderDetail} from "../../../api/graphql";

export abstract  class ChefsRepository {
    public  abstract getOrders(): Promise<Order[]>
    public abstract getOrderDetailsByIDOrder(idOrder: string): Promise<OrderDetail[]>
    public abstract getCategories(): Promise<Category[]>
}
